  import { useEffect, useRef } from 'react';
  import { useDispatch, useSelector } from 'react-redux';
  import { logout } from '../../redux/actions/authActions';
  import { persistor } from '../../redux/store';
  import { useNavigate } from 'react-router-dom';
  import { toast } from 'react-toastify';

  const useSessionTimeout = () => {
    const loginStatus = useSelector((state) => state.auth.loginStatus);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const logoutTimerRef = useRef(null);
    const isLoggingOut = useRef(false);

    const handleLogout = () => {
      isLoggingOut.current = true;
      // toast.success('Session expired. Please log in again to continue.');
      dispatch(logout());
      persistor.purge();
      setTimeout(() => {
        navigate('/login');
      }, 300);
    };

    const resetLogoutTimer = () => {
      if (logoutTimerRef.current) {
        // console.log('Clearing timeout');
        clearTimeout(logoutTimerRef.current);
      }
      if (loginStatus) {
        // console.log('Setting timeout');
        logoutTimerRef.current = setTimeout(() => {
          toast.info('Your session has expired. Please log in again to continue.');
          handleLogout();
        }, 3600000); //3600000
      }
    };

    useEffect(() => {
      const events = ['click', 'mousemove', 'keypress'];

      const handleUnload = () => {
        if (loginStatus && !isLoggingOut.current) {
          handleLogout();
        }
      };

      if (loginStatus) {
        // console.log('Adding event listeners');
        events.forEach(event => {
          window.addEventListener(event, resetLogoutTimer);
        });
        resetLogoutTimer();
        // window.addEventListener('unload', handleUnload);
      }

      return () => {
        // console.log('Removing event listeners');
        events.forEach(event => {
          window.removeEventListener(event, resetLogoutTimer);
        });
        // window.removeEventListener('unload', handleUnload);
        if (logoutTimerRef.current) {
          // console.log('Clearing final timeout');
          clearTimeout(logoutTimerRef.current);
        }
      };
    }, [loginStatus]);

    return null;
  };

  export default useSessionTimeout;